import cn from 'classnames';

import { IConDefaultType } from '..';

export enum SoundIconVariant {
  DEFAULT = 'default',
  ON = 'on',
  OFF = 'off',
}

export interface ISoundIconProps extends IConDefaultType {
  variant?: SoundIconVariant;
}

function SoundIcon({ color, className, size = 24, rotate, flip, variant = SoundIconVariant.DEFAULT }: ISoundIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SoundIconVariant.DEFAULT && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="8" fill="#ADB0B8" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9455 12.1094V7.88562C10.9455 7.56125 10.8525 7.2437 10.6776 6.97064C10.5027 6.69759 10.2533 6.4805 9.95888 6.34514C9.66446 6.20979 9.33744 6.16184 9.01663 6.207C8.69582 6.25216 8.39468 6.38852 8.14895 6.59991L6.96471 7.6142H6.66508C6.28667 7.6142 5.92376 7.76471 5.65618 8.03261C5.3886 8.30052 5.23828 8.66389 5.23828 9.04277V10.9475C5.23828 11.3264 5.3886 11.6898 5.65618 11.9577C5.92376 12.2256 6.28667 12.3761 6.66508 12.3761H6.97422L8.16322 13.3951C8.46647 13.66 8.85467 13.8071 9.2571 13.8094C9.50344 13.8092 9.7468 13.7556 9.9705 13.6523C10.2642 13.5165 10.5125 13.2987 10.6854 13.0249C10.8584 12.7512 10.9487 12.4333 10.9455 12.1094ZM13.5518 12.8522C13.4569 12.8524 13.3642 12.8242 13.2854 12.7712C13.2335 12.7363 13.189 12.6914 13.1545 12.6392C13.1199 12.587 13.096 12.5284 13.0841 12.4669C13.0721 12.4055 13.0724 12.3422 13.085 12.2809C13.0975 12.2195 13.122 12.1612 13.157 12.1093C13.5752 11.4828 13.7984 10.7462 13.7984 9.99266C13.7984 9.23912 13.5752 8.50251 13.157 7.87599C13.0891 7.76985 13.0659 7.64107 13.0927 7.51789C13.1194 7.3947 13.1939 7.28716 13.2997 7.21885C13.3515 7.18375 13.4097 7.15923 13.471 7.1467C13.5323 7.13417 13.5955 7.13386 13.6569 7.1458C13.7183 7.15775 13.7767 7.1817 13.8289 7.2163C13.881 7.2509 13.9259 7.29545 13.9608 7.34742C14.4832 8.13044 14.7621 9.05098 14.7621 9.99266C14.7621 10.9343 14.4832 11.8549 13.9608 12.6379C13.9164 12.7054 13.8555 12.7606 13.784 12.7981C13.7124 12.8355 13.6325 12.8542 13.5518 12.8522ZM12.187 11.9C12.0937 11.8992 12.0028 11.8711 11.9254 11.819C11.8204 11.7499 11.7469 11.6421 11.7211 11.5189C11.6952 11.3958 11.7191 11.2674 11.7875 11.1619C12.0155 10.8156 12.1371 10.41 12.1371 9.99521C12.1371 9.58044 12.0155 9.17479 11.7875 8.82854C11.7529 8.77609 11.729 8.7173 11.7172 8.65556C11.7054 8.59382 11.7059 8.53036 11.7187 8.46882C11.7316 8.40729 11.7564 8.34891 11.7919 8.29704C11.8274 8.24518 11.8727 8.20085 11.9254 8.16663C12.0302 8.09772 12.158 8.07306 12.281 8.09803C12.4039 8.123 12.512 8.19558 12.5817 8.29997C12.9146 8.80244 13.0917 9.39224 13.0906 9.99521C13.0893 10.5935 12.916 11.1787 12.5912 11.6809C12.5478 11.7487 12.488 11.8043 12.4173 11.8426C12.3466 11.8809 12.2674 11.9006 12.187 11.9Z"
            fill="white"
          />
        </svg>
      )}
      {variant === SoundIconVariant.OFF && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1615_27723)">
            <path
              d="M14 14.5098V16.4398C13.997 16.9038 13.8679 17.3582 13.6266 17.7545C13.3853 18.1508 13.0409 18.4741 12.63 18.6898C12.2192 18.9055 11.7575 19.0055 11.2942 18.979C10.831 18.9526 10.3836 18.8008 10 18.5398"
              stroke="#303037"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.54 16.46L7 16H6C5.46957 16 4.96086 15.7893 4.58579 15.4142C4.21071 15.0391 4 14.5304 4 14V9.99997C4 9.46954 4.21071 8.96083 4.58579 8.58576C4.96086 8.21069 5.46957 7.99997 6 7.99997H7L9.77 5.62997C10.1414 5.31031 10.5967 5.10396 11.0819 5.03542C11.5671 4.96688 12.0618 5.03903 12.5072 5.24331C12.9526 5.44759 13.33 5.7754 13.5946 6.18783C13.8593 6.60025 13.9999 7.07996 14 7.56997V9.99997"
              stroke="#303037"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M20 4L4 20" stroke="#303037" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_1615_27723">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === SoundIconVariant.ON && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.48 6.99121C20.4689 8.47342 20.9967 10.216 20.9967 11.9986C20.9967 13.7813 20.4689 15.5239 19.48 17.0061"
            stroke="#303037"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.6001 8.9942C17.1893 9.88491 17.5025 10.9302 17.5001 11.9987C17.5013 13.0655 17.192 14.1095 16.6101 15.0031"
            stroke="#303037"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 9.99547V14.0014C3 14.5326 3.21071 15.0421 3.58579 15.4177C3.96086 15.7934 4.46957 16.0044 5 16.0044H6L8.78 18.3879C9.15163 18.7049 9.60601 18.9089 10.0896 18.9759C10.5732 19.0428 11.0658 18.9698 11.5093 18.7656C11.9529 18.5614 12.3289 18.2345 12.593 17.8233C12.8571 17.4122 12.9983 16.9339 13 16.445V7.56186C12.9977 7.07205 12.8559 6.59305 12.5913 6.18113C12.3266 5.76921 11.9501 5.44148 11.506 5.23641C11.0618 5.03135 10.5684 4.95748 10.0838 5.02347C9.59914 5.08946 9.14337 5.29258 8.77 5.60897L6 7.9925H5C4.46957 7.9925 3.96086 8.20353 3.58579 8.57916C3.21071 8.95479 3 9.46425 3 9.99547Z"
            stroke="#303037"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </i>
  );
}

export default SoundIcon;
